// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetBboMarket (params?: {}): Promise<Dict>;
    publicGetBboMarketInteractive (params?: {}): Promise<Dict>;
    publicGetFundingData (params?: {}): Promise<Dict>;
    publicGetMarkets (params?: {}): Promise<Dict>;
    publicGetMarketsHistory (params?: {}): Promise<Dict>;
    publicGetMarketsKlines (params?: {}): Promise<Dict>;
    publicGetMarketsSettlementPrice (params?: {}): Promise<Dict>;
    publicGetMarketsSummary (params?: {}): Promise<Dict>;
    publicGetOrderbookMarket (params?: {}): Promise<Dict>;
    publicGetOrderbookMarketImpactPrice (params?: {}): Promise<Dict>;
    publicGetOrderbookMarketInteractive (params?: {}): Promise<Dict>;
    publicGetInsurance (params?: {}): Promise<Dict>;
    publicGetJwksJson (params?: {}): Promise<Dict>;
    publicGetOnboarding (params?: {}): Promise<Dict>;
    publicGetReferralsConfig (params?: {}): Promise<Dict>;
    publicGetStakingBalanceHistoryGlobal (params?: {}): Promise<Dict>;
    publicGetStakingConfig (params?: {}): Promise<Dict>;
    publicGetSystemAnnouncements (params?: {}): Promise<Dict>;
    publicGetSystemConfig (params?: {}): Promise<Dict>;
    publicGetSystemPortfolioMarginConfig (params?: {}): Promise<Dict>;
    publicGetSystemState (params?: {}): Promise<Dict>;
    publicGetSystemTime (params?: {}): Promise<Dict>;
    publicGetSystemVolumeTiers (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    publicGetVaults (params?: {}): Promise<Dict>;
    publicGetVaultsAnalytics (params?: {}): Promise<Dict>;
    publicGetVaultsBalance (params?: {}): Promise<Dict>;
    publicGetVaultsConfig (params?: {}): Promise<Dict>;
    publicGetVaultsHistory (params?: {}): Promise<Dict>;
    publicGetVaultsPositions (params?: {}): Promise<Dict>;
    publicGetVaultsSummary (params?: {}): Promise<Dict>;
    publicGetVaultsTransfers (params?: {}): Promise<Dict>;
    publicGetXpFeeConfig (params?: {}): Promise<Dict>;
    publicGetXpPublicTransfers (params?: {}): Promise<Dict>;
    publicGetXpTransferTransferId (params?: {}): Promise<Dict>;
    privateGetAccount (params?: {}): Promise<List>;
    privateGetAccountCompliance (params?: {}): Promise<Dict>;
    privateGetAccountHistory (params?: {}): Promise<Dict>;
    privateGetAccountInfo (params?: {}): Promise<Dict>;
    privateGetAccountMargin (params?: {}): Promise<Dict>;
    privateGetAccountProfile (params?: {}): Promise<Dict>;
    privateGetAccountSettings (params?: {}): Promise<Dict>;
    privateGetAccountSubaccounts (params?: {}): Promise<Dict>;
    privateGetAccountSummary (params?: {}): Promise<Dict>;
    privateGetBalance (params?: {}): Promise<Dict>;
    privateGetFills (params?: {}): Promise<Dict>;
    privateGetFundingPayments (params?: {}): Promise<Dict>;
    privateGetPositions (params?: {}): Promise<Dict>;
    privateGetTradebusts (params?: {}): Promise<Dict>;
    privateGetTransactions (params?: {}): Promise<Dict>;
    privateGetAccountKeysSubkeys (params?: {}): Promise<Dict>;
    privateGetAccountKeysSubkeysPublicKey (params?: {}): Promise<Dict>;
    privateGetAccountTokens (params?: {}): Promise<Dict>;
    privateGetAlgoOrders (params?: {}): Promise<Dict>;
    privateGetAlgoOrdersHistory (params?: {}): Promise<Dict>;
    privateGetAlgoOrdersAlgoId (params?: {}): Promise<Dict>;
    privateGetBlockTrades (params?: {}): Promise<Dict>;
    privateGetBlockTradesBlockTradeId (params?: {}): Promise<Dict>;
    privateGetBlockTradesBlockTradeIdOffers (params?: {}): Promise<Dict>;
    privateGetBlockTradesBlockTradeIdOffersOfferId (params?: {}): Promise<Dict>;
    privateGetLiquidations (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<Dict>;
    privateGetOrdersHistory (params?: {}): Promise<Dict>;
    privateGetOrdersByClientIdClientId (params?: {}): Promise<Dict>;
    privateGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetReferralsQrCode (params?: {}): Promise<Dict>;
    privateGetReferralsSummary (params?: {}): Promise<Dict>;
    privateGetRfqs (params?: {}): Promise<Dict>;
    privateGetRfqsDrafts (params?: {}): Promise<Dict>;
    privateGetRfqsMarkets (params?: {}): Promise<Dict>;
    privateGetRfqsRfqIdBbo (params?: {}): Promise<Dict>;
    privateGetStakingBalanceHistory (params?: {}): Promise<Dict>;
    privateGetStakingHistory (params?: {}): Promise<Dict>;
    privateGetStakingSummary (params?: {}): Promise<Dict>;
    privateGetTransfers (params?: {}): Promise<Dict>;
    privateGetVaultsAccountSummary (params?: {}): Promise<Dict>;
    privateGetVaultsMine (params?: {}): Promise<Dict>;
    privateGetXpAccountBalance (params?: {}): Promise<Dict>;
    privateGetXpTransfers (params?: {}): Promise<Dict>;
    privatePostAccountCompliance (params?: {}): Promise<Dict>;
    privatePostAccountMarginMarket (params?: {}): Promise<Dict>;
    privatePostAccountProfileMarketMaxSlippageMarket (params?: {}): Promise<Dict>;
    privatePostAccountProfileNotifications (params?: {}): Promise<Dict>;
    privatePostAccountProfileNotificationsLastSeen (params?: {}): Promise<Dict>;
    privatePostAccountProfileReferralCode (params?: {}): Promise<Dict>;
    privatePostAccountProfileRefreshInventory (params?: {}): Promise<Dict>;
    privatePostAccountProfileSizeCurrencyDisplay (params?: {}): Promise<Dict>;
    privatePostAccountProfileUsername (params?: {}): Promise<Dict>;
    privatePostAccountReferrer (params?: {}): Promise<Dict>;
    privatePostAccountSettingsTradingValueDisplay (params?: {}): Promise<Dict>;
    privatePostAccountParadigmEnable (params?: {}): Promise<Dict>;
    privatePostAccountTerminalToken (params?: {}): Promise<Dict>;
    privatePostAccountKeysSubkeysActivate (params?: {}): Promise<Dict>;
    privatePostAccountKeysSubkeys (params?: {}): Promise<Dict>;
    privatePostAccountTokens (params?: {}): Promise<Dict>;
    privatePostAlgoOrders (params?: {}): Promise<Dict>;
    privatePostAuth (params?: {}): Promise<Dict>;
    privatePostBlockTrades (params?: {}): Promise<Dict>;
    privatePostBlockTradesBlockTradeIdExecute (params?: {}): Promise<Dict>;
    privatePostBlockTradesBlockTradeIdOffers (params?: {}): Promise<Dict>;
    privatePostBlockTradesBlockTradeIdOffersOfferIdExecute (params?: {}): Promise<Dict>;
    privatePostOnboarding (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersBatch (params?: {}): Promise<Dict>;
    privatePostRfqs (params?: {}): Promise<Dict>;
    privatePostRfqsDrafts (params?: {}): Promise<Dict>;
    privatePostRfqsRfqIdExecute (params?: {}): Promise<Dict>;
    privatePostV2Auth (params?: {}): Promise<Dict>;
    privatePostV2Onboarding (params?: {}): Promise<Dict>;
    privatePostVaults (params?: {}): Promise<Dict>;
    privatePostXpTransfer (params?: {}): Promise<Dict>;
    privatePutAccountProfile (params?: {}): Promise<Dict>;
    privatePutAccountKeysSubkeysPublicKey (params?: {}): Promise<Dict>;
    privatePutAccountKeysSubkeysPublicKeyAllowedCidrs (params?: {}): Promise<Dict>;
    privatePutAccountTokensLookupIdAllowedCidrs (params?: {}): Promise<Dict>;
    privatePutOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteAccountKeysSubkeysPublicKey (params?: {}): Promise<Dict>;
    privateDeleteAccountTokensLookupId (params?: {}): Promise<Dict>;
    privateDeleteAlgoOrdersAlgoId (params?: {}): Promise<Dict>;
    privateDeleteBlockTradesBlockTradeId (params?: {}): Promise<Dict>;
    privateDeleteBlockTradesBlockTradeIdOffersOfferId (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<Dict>;
    privateDeleteOrdersBatch (params?: {}): Promise<Dict>;
    privateDeleteOrdersByClientIdClientId (params?: {}): Promise<Dict>;
    privateDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteRfqsDraftsDraftId (params?: {}): Promise<Dict>;
    privateDeleteRfqsRfqId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
